// Dependencies
import Vue from "vue";
import * as vComponents from "./components";

// Import global CSS
import "./sass/global.scss";

// Support Vue components in Sitecore Experience Editor
/*global Sitecore*/
/*eslint no-undef: "error"*/
if (typeof Sitecore !== typeof undefined) {
  document
    .querySelectorAll('code[type="text/sitecore"]')
    .forEach(el => el.setAttribute("v-pre", ""));

  // extend the Sitecore placeholder chrome type
  Sitecore.PageModes.ChromeTypes.Placeholder = Sitecore.PageModes.ChromeTypes.Placeholder.extend(
    {
      insertRendering(data, openProperties) {
        // call the base insertRendering() before processing
        this.base(data, openProperties);

        // check all of the renderings in this placeholder as they are all reset
        Array.prototype.forEach.call(this.chrome.element, element => {
          const Placeholder = Vue.extend({
            template: element.outerHTML
          });

          new Placeholder().$mount(element);
        });

        // Reset the chrome in Experience Editor after the Vue rendering pipeline is complete
        Sitecore.PageModes.ChromeManager.resetChromes();
      }
    },
    {
      emptyLookFillerCssClass:
        Sitecore.PageModes.ChromeTypes.Placeholder.emptyLookFillerCssClass,
      getDefaultAjaxOptions:
        Sitecore.PageModes.ChromeTypes.Placeholder.getDefaultAjaxOptions
    }
  );
}

// Register all components
Object.values(vComponents).forEach(vComponent => {
  Vue.use(vComponent);
});

// Expose Vue globally
window.Vue = Vue;

// Instantiate Vue
document.querySelectorAll("[v-app]").forEach(el => new Vue({ el }));
